const e = {
  name: "Exit",
  dimensions: { width: 18, height: 17 },
  content: `
        <path fill-rule="evenodd" clip-rule="evenodd" d="M12.2929 13.4571C11.9024 13.0666 11.9024 12.4334 12.2929 12.0429L14.5858 9.75H8C7.44772 9.75 7 9.30229 7 8.75C7 8.19772 7.44772 7.75 8 7.75L14.5858 7.75L12.2929 5.45711C11.9024 5.06658 11.9024 4.43342 12.2929 4.04289C12.6834 3.65237 13.3166 3.65237 13.7071 4.04289L17.7071 8.04289C18.0976 8.43342 18.0976 9.06658 17.7071 9.45711L13.7071 13.4571C13.3166 13.8476 12.6834 13.8476 12.2929 13.4571Z" fill="currentColor"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M8 2.75C8.55228 2.75 9 2.30228 9 1.75C9 1.19772 8.55228 0.75 8 0.75C3.58172 0.75 1.93129e-07 4.33172 0 8.75C-1.93129e-07 13.1683 3.58172 16.75 8 16.75C8.55228 16.75 9 16.3023 9 15.75C9 15.1977 8.55228 14.75 8 14.75C4.68629 14.75 2 12.0637 2 8.75C2 5.43629 4.68629 2.75 8 2.75Z" fill="currentColor"/>`
};
export {
  e as Exit
};
